import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  verify: () => api.get('/auth/verify'),
  changePassword: (passwords) => api.post('/auth/change-password', passwords)
};

// Customers API
export const customersAPI = {
  getAll: (params) => api.get('/customers', { params }),
  getOne: (id) => api.get(`/customers/${id}`),
  uploadCSV: (formData) => api.post('/customers/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  delete: (id) => api.delete(`/customers/${id}`)
};

// Analytics API
export const analyticsAPI = {
  getOverview: (params) => api.get('/analytics', { params }),
  getRetention: () => api.get('/analytics/retention'),
  getMonths: () => api.get('/analytics/months')
};

// Preferences API
export const preferencesAPI = {
  get: () => api.get('/preferences'),
  update: (preferences) => api.put('/preferences', { preferences }),
  reset: () => api.delete('/preferences'),
  updateKey: (key, value) => api.patch(`/preferences/${key}`, { value })
};

// Events API
export const eventsAPI = {
  getPublic: () => api.get('/events'),
  getAll: () => api.get('/events/admin'),
  create: (formData) => api.post('/events', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  update: (id, formData) => api.put(`/events/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  delete: (id) => api.delete(`/events/${id}`)
};

// Announcement API
export const announcementAPI = {
  get: () => api.get('/announcement'),
  update: (data) => api.put('/announcement', data)
};

export default api;
